<template>
  <svg xmlns="http://www.w3.org/2000/svg" stroke="currentColor" viewBox="0 0 300 300" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">
    <path d="M159.5,171.8l-61.9,25.6L194.1,27.4v123l61.9-25.6h-.4l-96.1,170.2v-123M256,124.8l-53.6-22.2M194.1,27.2l-53.6-22.2L44,175.3l53.6,22.2M105.9,194.5v78.1l53.6,22.2M202.4,102.5l-8.2,3.4" />
  </svg>
</template>
